// Modell-Menue: Reiter wechseln per Hover (Maus), Klick oder Pfeiltasten.
// Farbpunkte: Maus darueber -> Kachelbild faehrt zur Farbe (Karussell), Link zeigt auf dieses Produkt;
// Maus verlaesst die Kachel -> zurueck zum Startbild.
const SLIDE_DURATION = 450;
const SLIDE_EASING = 'cubic-bezier(.7, 0, .3, 1)';

if (!customElements.get('mm-models')) {
  class MmModels extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-mm-tab]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.select(tab);
        });
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });

      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse') return;
        const dot = event.target.closest('.mm-card__dots i[data-mm-src]');
        if (dot) this.showColor(dot.closest('.mm-card'), dot);
      });
      this.querySelectorAll('.mm-card').forEach((card) => {
        card.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.resetColor(card);
        });
      });
    }

    select(tab) {
      const id = tab.dataset.mmTab;
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', active);
        t.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-mm-panel]').forEach((p) => (p.hidden = p.dataset.mmPanel !== id));
      this.querySelectorAll('[data-mm-side]').forEach((s) => (s.hidden = s.dataset.mmSide !== id));
    }

    onKeydown(event, tab) {
      const step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      const next = this.tabs[(this.tabs.indexOf(tab) + step + this.tabs.length) % this.tabs.length];
      this.select(next);
      next.focus();
    }

    showColor(card, dot) {
      const dots = [...card.querySelectorAll('.mm-card__dots i')];
      if (!card._mm) {
        const img = card.querySelector('.mm-card__media img');
        if (!img) return;
        card._mm = {
          image: img,
          original: { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), url: card.getAttribute('href') },
          shownKey: 'original',
          shownPosition: 0,
        };
      }
      dots.forEach((d) => d.classList.toggle('is-active', d === dot));
      card.setAttribute('href', dot.dataset.mmUrl);
      this.slideTo(card, { src: dot.dataset.mmSrc, srcset: dot.dataset.mmSrcset }, dot.dataset.mmSrc, dots.indexOf(dot));
    }

    resetColor(card) {
      if (!card._mm) return;
      card.querySelectorAll('.mm-card__dots i').forEach((d) => d.classList.remove('is-active'));
      card.setAttribute('href', card._mm.original.url);
      this.slideTo(card, card._mm.original, 'original', 0);
    }

    // Wie die Produktkarte (card-variant-picker): altes Bild faehrt raus, neues kommt von der anderen Seite.
    async slideTo(card, source, key, position) {
      const state = card._mm;
      if (key === state.shownKey) return;
      const token = (state.token = (state.token || 0) + 1);
      const direction = position < state.shownPosition ? -1 : 1;
      state.shownKey = key;
      state.shownPosition = position;

      const next = state.image.cloneNode(false);
      next.removeAttribute('loading');
      if (source.srcset) next.setAttribute('srcset', source.srcset);
      else next.removeAttribute('srcset');
      next.setAttribute('src', source.src);
      try {
        await next.decode();
      } catch (e) {
        /* Bild trotzdem zeigen */
      }
      if (token !== state.token) return;

      if (state.slide) state.slide.forEach((animation) => animation.finish());
      const previous = state.image;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !previous.isConnected) {
        previous.replaceWith(next);
        state.image = next;
        return;
      }
      next.classList.add('mm-slide-in');
      previous.after(next);
      state.image = next;
      const options = { duration: SLIDE_DURATION, easing: SLIDE_EASING };
      const outgoing = previous.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-100 * direction}%)` }], options);
      const incoming = next.animate([{ transform: `translateX(${100 * direction}%)` }, { transform: 'translateX(0)' }], options);
      state.slide = [outgoing, incoming];
      incoming.finished
        .catch(() => {})
        .then(() => {
          previous.remove();
          next.classList.remove('mm-slide-in');
          if (state.slide && state.slide[1] === incoming) state.slide = null;
        });
    }
  }
  customElements.define('mm-models', MmModels);
}
